enum BookingAction {
  ACCEPT = 1,
  REJECT = 2,
  REMOVE = 3,
  CANCEL = 4,
}

export default BookingAction;
